import {
  Film,
  ShoppingBag,
  Plane,
  Stethoscope,
  Heart,
  Home,
  Briefcase,
  TreePine,
  ChefHat,
  Trophy,
  Dumbbell,
  Laugh,
  Wine,
  Coffee,
  GraduationCap,
  Music,
  UtensilsCrossed,
  Music2,
  Palette,
  PartyPopper
} from 'lucide-react';

export const SERVICES = [
  { id: "movies", name: "Movies", icon: Film, description: "Partner for movie outings", color: "bg-red-500" },
  { id: "shopping", name: "Shopping", icon: ShoppingBag, description: "Shopping partner", color: "bg-pink-500" },
  { id: "travel", name: "Travel", icon: Plane, description: "Travel buddy", color: "bg-blue-500" },
  { id: "medical_help", name: "Medical Help", icon: Stethoscope, description: "Medical assistance", color: "bg-green-500" },
  { id: "elder_care", name: "Elder Care", icon: Heart, description: "Elderly care assistance", color: "bg-rose-500" },
  { id: "domestic_help", name: "Domestic Help", icon: Home, description: "Household assistance", color: "bg-amber-500" },
  { id: "business_events", name: "Business Events", icon: Briefcase, description: "Corporate event partner", color: "bg-slate-700" },
  { id: "outdoor_events", name: "Outdoor Events", icon: TreePine, description: "Outdoor activities", color: "bg-emerald-500" },
  { id: "baking_cooking", name: "Baking/Cooking", icon: ChefHat, description: "Cooking partner", color: "bg-orange-500" },
  { id: "sporting_events", name: "Sporting Events", icon: Trophy, description: "Sports event partner", color: "bg-yellow-500" },
  { id: "playing_sports", name: "Playing Sports", icon: Dumbbell, description: "Sports partner", color: "bg-cyan-500" },
  { id: "comedy_club", name: "Comedy Club", icon: Laugh, description: "Comedy show partner", color: "bg-purple-500" },
  { id: "going_to_bar", name: "Going to Bar", icon: Wine, description: "Bar partner", color: "bg-violet-500" },
  { id: "hanging_out", name: "Hanging Out", icon: Coffee, description: "Casual hangout", color: "bg-teal-500" },
  { id: "tutoring", name: "Tutoring", icon: GraduationCap, description: "Educational assistance", color: "bg-indigo-500" },
  { id: "clubbing", name: "Clubbing", icon: Music, description: "Nightclub partner", color: "bg-fuchsia-500" },
  { id: "dinner", name: "Dinner", icon: UtensilsCrossed, description: "Dinner partner", color: "bg-red-600" },
  { id: "music", name: "Music", icon: Music2, description: "Concert/Music partner", color: "bg-sky-500" },
  { id: "culture", name: "Culture", icon: Palette, description: "Cultural events", color: "bg-lime-500" },
  { id: "parties", name: "Parties", icon: PartyPopper, description: "Party partner", color: "bg-pink-600" }
];

export const MEMBERSHIP_PLANS = {
  "6_months": { 
    id: "6_months",
    price: 249, 
    gst: 18, 
    total: 294, 
    validity: "6 Months",
    features: ["Profile Activation", "Accept Bookings", "Earn 80% of fees", "Basic Support"]
  },
  "5_years": { 
    id: "5_years",
    price: 499, 
    gst: 18, 
    total: 589, 
    validity: "5 Years",
    popular: true,
    features: ["Profile Activation", "Accept Bookings", "Earn 80% of fees", "Priority Support", "Featured Listing"]
  },
  "lifetime": { 
    id: "lifetime",
    price: 999, 
    gst: 18, 
    total: 1179, 
    validity: "Lifetime",
    features: ["Profile Activation", "Accept Bookings", "Earn 80% of fees", "24/7 VIP Support", "Featured Listing", "Verified Badge"]
  }
};

export const getServiceById = (id) => SERVICES.find(s => s.id === id);
export const getServiceIcon = (id) => {
  const service = getServiceById(id);
  return service ? service.icon : Film;
};
